import MapComponent from '@Core/components/map';
import MapEmbed from '@Core/components/map/mapEmbed';
import { ComponentLoader } from '@bythepixel/component-loader';
import DepartmentTabs from '@Front/modules/pages/locationDetails/departmentTabs';

const headerContent = document.querySelector(
  '[data-comp-location-header-content]',
);
const locationMap = document.querySelector('#mapLayout');
locationMap.style.height = `${headerContent.offsetHeight}px`;

window.locationDetailsMap = new ComponentLoader(
  document,
  [MapComponent],
  () => {
    const map = window.locationDetailsMap.getRegistry().entries().next()
      .value[1].instance;

    window.locationDetails = new ComponentLoader(document, [
      DepartmentTabs,
      [
        MapEmbed,
        {
          map,
        },
      ],
    ]);
  },
);
